import { Flex, FlexMiddle } from '@ubeya/shared-web/components';
import React, { useCallback } from 'react';
import styled from 'styled-components';

const Wrapper = styled(FlexMiddle)`
  justify-content: center;
  position: relative;
  cursor: pointer;
  width: 100%;
  background: transparent;
`;

const BreakPlotWrapper = styled(Wrapper)``;

const BreakPlotCard = styled(Flex)`
  flex: 1;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.grey2};
  opacity: 0.6;
  height: 46px;
  z-index: 1;
  align-items: center;
  justify-content: center;
`;

const BreakPlotsRenderer = ({ index, data, employeeId, offset, onDayClick, mappedBreakTypes, maxBucket }) => {
  const { employeesSlotsBreakPlots = [] } = data;

  const isEmpty = useCallback((value) => value === 'undefined' || value === null, []);

  const employeesSlotsBreakPlotsBuckets = employeesSlotsBreakPlots.map((breakplot) => {
    const breakPlotWrapperStyle =
      !isEmpty(breakplot.startBucketNum) && !isEmpty(breakplot.endBucketNum)
        ? {
            gridColumnStart: breakplot.startBucketNum - offset + 2,
            gridColumnEnd: Math.min(breakplot.endBucketNum - offset + 2, maxBucket),
            gridRowStart: 1,
            gridRowEnd: 1
          }
        : {};
    return { ...breakplot, breakPlotWrapperStyle };
  });

  const onBookedShiftClick = useCallback(() => onDayClick({ ...data, employeeId, selectedBucket: index }), [
    data,
    employeeId,
    index,
    onDayClick
  ]);

  return employeesSlotsBreakPlotsBuckets.map((breakplot) => (
    <BreakPlotWrapper key={breakplot.id} style={breakplot.breakPlotWrapperStyle}>
      <BreakPlotCard onClick={onBookedShiftClick}>
        {breakplot?.breakTypeId ? mappedBreakTypes[breakplot.breakTypeId]?.title?.charAt(0)?.toUpperCase() : 'B'}
      </BreakPlotCard>
    </BreakPlotWrapper>
  ));
};

export default React.memo(BreakPlotsRenderer);
